import * as ServiceClient from './service-clients'
import Vue from 'vue'

const factory = {}

factory.create = function(serviceConstructor) {
  const accessToken = Vue.cookie.get('accessToken')

  const baseUrl = process.env.API_URL
  const http = {
    fetch: function (url, init) {
      window.Pace.restart()
      init.headers.append('Authorization', 'Bearer ' + accessToken)
      return window.fetch(url, init)
    }
  }

  return new serviceConstructor(baseUrl, http)
}

export default factory



// WEBPACK FOOTER //
// ./src/shared/service-clients/serviceClientFactory.js